class RtmEpisode {
    readonly id: number | undefined
    readonly createdById: number | undefined
    readonly createdAt: string | undefined
    readonly modifiedAt: string | undefined
    readonly modifiedById: number | undefined
    readonly dischargedById: number | undefined
    readonly withinSchedule: boolean
    readonly withinScheduleCode: string
    endDate: string
    ownerName: string | undefined
    ownerSlug: string | undefined
    patientId: number
    patientJourneyId: number | undefined
    rtmClinicianId: number | undefined
    startDate: string
    teamId: number | undefined
    collectionStartDate: string | undefined
    collectionEndDate: string | undefined
    collectionDaysCount: number | undefined

    constructor(object: Partial<RtmEpisode>) {
        this.endDate = object.endDate || ''
        this.rtmClinicianId = object.rtmClinicianId || undefined
        this.modifiedById = object.modifiedById || undefined
        this.createdById = object.createdById || undefined
        this.modifiedAt = object.modifiedAt || undefined
        this.dischargedById = object.dischargedById || undefined
        this.startDate = object.startDate || ''
        this.ownerName = object.ownerName || undefined
        this.ownerSlug = object.ownerSlug || undefined
        this.withinSchedule = object.withinSchedule || false
        this.teamId = object.teamId || undefined
        this.id = object.id || undefined
        this.createdAt = object.createdAt || undefined
        this.patientId = object.patientId!
        this.patientJourneyId = object.patientJourneyId || undefined
        this.withinScheduleCode = object.withinScheduleCode || ''
        this.collectionStartDate = object.collectionStartDate || undefined
        this.collectionEndDate = object.collectionEndDate || undefined
        this.collectionDaysCount = object.collectionDaysCount || undefined
    }
}

export default RtmEpisode
